module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-08-da118a9bc6252a74db89a77d4da8012c.jpg";